(() => {
  if (window.smoothScrollLinksInitialized) return;
  window.smoothScrollLinksInitialized = true;

  const prefersReducedMotion = () => (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  const findTarget = (value) => {
    const targetValue = String(value || '').trim();
    if (!targetValue || targetValue === 'top') return null;

    const elementId = targetValue.startsWith('#')
      ? targetValue.slice(1)
      : targetValue;
    const elementById = document.getElementById(elementId);
    if (elementById) return elementById;

    try {
      return document.querySelector(targetValue);
    } catch (error) {
      console.warn('[Smooth scroll] Invalid target selector.', targetValue);
      return null;
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-smooth-scroll-target]');
    if (!link) return;

    const targetValue = String(link.dataset.smoothScrollTarget || '').trim();
    const behavior = prefersReducedMotion() ? 'auto' : 'smooth';

    if (targetValue === 'top') {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior });
      return;
    }

    const target = findTarget(targetValue);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior, block: 'start' });
  });
})();
